import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #5C4033;
    --secondary-color: #8B7355;
    --accent-color: #DAA520;
    --background-color: #F5F5DC;
    --text-color: #3E2723;
    --error-color: #8B4513;
    --success-color: #556B2F;
    --border-radius: 4px;
    --box-shadow: 0 2px 4px rgba(92, 64, 51, 0.1);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Cormorant Garamond', Calibri, serif;
    background-color: var(--background-color);
    color: var(--text-color);
    line-height: 1.6;
  }

  a {
    text-decoration: none;
    color: var(--accent-color);
  }

  button {
    cursor: pointer;
  }

  .css-156o99d-MuiPaper-root-MuiAppBar-root {
    position: relative !important;
  }

  /* Responsive breakpoints */
  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    html {
      font-size: 12px;
    }
  }
`;

export default GlobalStyles;